import { FormControlLabel, Radio, RadioGroup } from '@mui/material'
import React from 'react'
import { Controller, UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { MoveOutFormFields } from '../MoveOutWizard'

interface MoveoutTypeStepProps {
	form: UseFormReturn<MoveOutFormFields>
}

const MoveoutTypeStep: React.FC<MoveoutTypeStepProps> = ({ form }) => {
	const { t } = useTranslation('modals_moveOutContact')

	return (
		<Controller
			control={form.control}
			name={'type'}
			defaultValue={form?.getValues()?.type ?? 'continue_contract'}
			render={({ field }) => (
				<RadioGroup {...field} sx={{ gap: 2 }}>
					<FormControlLabel
						className='text-text-dark dark:text-white'
						value='new_contract'
						control={<Radio color='primary' />}
						label={t('moveoutTypeStep.newContract')}
					/>
					<FormControlLabel
						className='text-text-dark dark:text-white'
						value='no_contract'
						control={<Radio color='primary' />}
						label={t('moveoutTypeStep.noContract')}
					/>
				</RadioGroup>
			)}
		/>
	)
}

export default MoveoutTypeStep
